import { PropsWithChildren, useEffect } from 'react';

import { useAuthStore } from '@stores/auth-store';

const AuthProvider = ({ children }: PropsWithChildren) => {
    const { fetchSession, fetchOAuthToken } = useAuthStore();

    useEffect(() => {
        fetchOAuthToken();
        fetchSession();
    }, []);

    return <>{children}</>;
};

export default AuthProvider;
